
app.ipaddress = (function () {
    var IPAddress = {
        init: function () {
            $(document).on('click', '[data-role="assign-address"]', function () {
                $(this).html("Assigning..." + $('[data-role="loading-gif"]').parent().html());
                $('[data-role="loading-gif"]', this).show();
                $(this).attr('disabled', 'disabled');
                $(this).css('background-color', 'white');
                $(this).css('color', '#c5050c');
            });
        }
    };
    return IPAddress;
})